import { Controller } from "@hotwired/stimulus"

// Reveals the Bewirtung (business-meal) Pflichtangaben when the toggle is checked
// and surfaces the >= 250 EUR §14-invoice warning. The amount lives outside this
// controller's element, so it is looked up by its extraction target attribute.
export default class extends Controller {
  static targets = ["checkbox", "section", "warning", "invoiceComplete"]
  static values = { invoiceThreshold: { type: Number, default: 250 } }

  connect() {
    this.amountInput = document.querySelector('[data-expense-receipt-extraction-target="amount"]')
    if (this.amountInput) {
      this.onAmountInput = () => this.recompute()
      this.amountInput.addEventListener("input", this.onAmountInput)
    }
    this.toggle()
  }

  disconnect() {
    if (this.amountInput && this.onAmountInput) {
      this.amountInput.removeEventListener("input", this.onAmountInput)
    }
  }

  toggle() {
    const on = this.checkboxTarget.checked
    this.sectionTarget.classList.toggle("hidden", !on)
    this.recompute()
  }

  recompute() {
    if (!this.hasWarningTarget) return
    const on = this.checkboxTarget.checked
    const amount = parseFloat((this.amountInput?.value || "").replace(",", ".")) || 0
    const invoiceComplete = this.hasInvoiceCompleteTarget
      ? this.invoiceCompleteTarget.checked
      : false
    const show = on && amount >= this.invoiceThresholdValue && !invoiceComplete
    this.warningTarget.classList.toggle("hidden", !show)
  }
}
